<!-- 翻译添加/编辑弹窗 -->
<template>
  <el-dialog title="" width="600px" custom-class="dialog_center" :visible.sync="dialogVisible" @close="hide"
    :before-close="beforeClose" :close-on-press-escape="!uploading" :close-on-click-modal="!uploading"
    :show-close="!uploading">
    <div class="dialog_scroll" v-loading="uploading">
      <el-form @submit.native.prevent label-width="100px" ref="form" :model="data">
        <el-form-item :label="`${$ts('原值')}：`" prop="title">
          <el-input v-model="data.title" disabled :type="inputType" />
        </el-form-item>
        <el-form-item :label="`${$ts('中文')}：`" prop="title_cn">
          <el-input v-model="data.title_cn" :placeholder="$ts('请输入')" :type="inputType" clearable maxlength="50000" />
        </el-form-item>
        <el-form-item :label="`${$ts('英文')}：`" prop="title_en">
          <el-input v-model="data.title_en" :placeholder="$ts('请输入')" :type="inputType" clearable maxlength="50000" />
        </el-form-item>
        <el-form-item :label="`${$ts('泰文')}：`" prop="title_th">
          <el-input v-model="data.title_th" :placeholder="$ts('请输入')" :type="inputType" clearable maxlength="50000" />
        </el-form-item>
        <el-form-item :label="`${$ts('高棉语')}：`" prop="title_km">
          <el-input v-model="data.title_km" :placeholder="$ts('请输入')" :type="inputType" clearable maxlength="50000" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog_footer">
      <el-button :loading="uploading" @click="dialogVisible = false">{{$ts('取消')}}</el-button>
      <el-button type="primary" :loading="uploading" @click="confirm">{{$ts('确定')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {
    throttleFn
  } from '@/assets/js/tool'
  export default {
    name: 'plat-locale',
    data() {
      return {
        dialogVisible: false, //弹框
        isConfirm: false, //是否点击确认 用于判定关闭窗口回调
        uploading: false, //提交数据
        inputType: 'text',
        data: {
          source: '',
          type: '',
          title: '',
          title_cn: '',
          title_en: '',
          title_th: '',
          title_km: '',
        }, //传入数据
        callback: null
      }
    },
    methods: {
      // 显示弹框
      show(data = {}) {
        for (let key in this.data) {
          this.data[key] = '';
        }
        this.data.title = data.title || '';
        if (!this.data.title) {
          this.$message.warning(this.$ts('请先输入翻译词'))
          return
        }
        this.data.source = data.source;
        this.data.type = data.type;
        this.inputType = data.input_type || 'text';
        this.callback = data.callback || null;
        this.isConfirm = false;
        this.dialogVisible = true;
        this.getDetail()
      },
      // 隐藏弹框
      hide() {
        let type = this.isConfirm ? 'confirm' : 'hide';
      },
      // 隐藏弹框前回调
      beforeClose(done) {
        if (!this.uploading) {
          done()
        } else {
          this.$message.error(this.$ts('正在提交数据，无法关闭'))
        }
      },
      // 确认数据
      confirm: throttleFn(function() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.confirmRequest(this.data)
          } else {
            return false
          }
        })
      }),
      // 提交数据
      confirmRequest(params) {
        if (this.uploading) return
        this.uploading = true;
        this.request({
          url: '/admin/language/set',
          data: params,
          is_public: true,
          complete: res => {
            if (res.error_code == 0) {
              if (this.callback) {
                this.callback()
              }
              this.isConfirm = true;
              this.dialogVisible = false;
            } else {
              this.$message.error('' + res.error_msg)
            }
            this.uploading = false;
          },
          fail: err => {
            this.$message.error(`${this.$ts('提交失败')}: ` + err)
          }
        })
      },
      getDetail() {
        this.uploading = true;
        this.request({
          url: '/admin/language/get_by_title',
          data: {
            source: this.data.source,
            type: this.data.type,
            title: this.data.title
          },
          is_public: true,
          complete: res => {
            if (res.error_code == 0) {
              this.isConfirm = false;
              this.dialogVisible = true;
              if (res.data.title) {
                for (let key in this.data) {
                  this.data[key] = res.data[key];
                }
              }
            } else {
              this.$message.error('' + res.error_msg)
            }
            this.uploading = false;
          },
          fail: err => {
            this.$message.error(`${this.$ts('提交失败')}: ` + err)
          }
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/modal/plat-locale.vue